export default {
  setMembers(state, data) {
    state.members = {
      ...state.members,
      active: [...state.members.active, ...data.members.active],
      inactive: [...state.members.inactive, ...data.members.inactive],
      totalMembers: data.totalMembers
    }
  },
  setFilterByName(state, name) {
    state.filters = {
      ...state.filters,
      name
    }
  },
  resetMembers(state) {
    state.members = {
      active: [],
      inactive: [],
      loading: false,
      page: 0,
      totalMembers: 0
    }
  },
  setFilterByStatus(state, status) {
    state.filters = {
      ...state.filters,
      status
    }
  },
  clearFilters(state) {
    state.filters = {
      name: '',
      status: 'active'
    }
  },
  fetchingMembers(state) {
    state.members.loading = true
  },
  fetchedMembers(state) {
    state.members.loading = false
  },
  deactivatingMember(state) {
    state.member.deactivating = true
  },
  deactivatedMember(state) {
    state.member.deactivating = false
  },
  generatingLinks(state) {
    state.member.generatingLinks = true
  },
  generatedLinks(state) {
    state.member.generatingLinks = false
  },
  resetLinks(state) {
    state.member.enrollmentLinks = []
  },
  setCorporateInvite(state, corporateInvite) {
    state.member.corporateInvite = corporateInvite
  },
  setEnrollmentLinks(state, links) {
    state.member.enrollmentLinks = links
  },
  setCurrentFilteredPage(state, page) {
    state.members.page = parseInt(page)
  }
}
